/**
 * gRPC canonical status names, indexed by their code (0 = OK ... 16 = UNAUTHENTICATED). Stable-semconv
 * SDKs (Go otelgrpc v0.71+) write the name into `rpc.response.status_code`; the SPM spans table needs
 * the code back.
 *
 * The ERROR Lucene clause enumerates the non-OK names on purpose: the tag is a string, so an open
 * range is lexicographic ("OK" > "1"), and the attribute is shared with other RPC systems (JSON-RPC,
 * Connect), so `NOT "OK"` over-matches.
 */
export const GRPC_STATUS_NAMES = [
    'OK',
    'CANCELLED',
    'UNKNOWN',
    'INVALID_ARGUMENT',
    'DEADLINE_EXCEEDED',
    'NOT_FOUND',
    'ALREADY_EXISTS',
    'PERMISSION_DENIED',
    'RESOURCE_EXHAUSTED',
    'FAILED_PRECONDITION',
    'ABORTED',
    'OUT_OF_RANGE',
    'UNIMPLEMENTED',
    'INTERNAL',
    'UNAVAILABLE',
    'DATA_LOSS',
    'UNAUTHENTICATED',
];
export const GRPC_ERROR_STATUS_NAMES = GRPC_STATUS_NAMES.slice(1);
/** Numeric gRPC code for a canonical name; undefined for anything else (other RPC systems write their own codes here). */
export const getGrpcStatusCode = (value) => {
    const code = typeof value === 'string' ? GRPC_STATUS_NAMES.indexOf(value) : -1;
    return code === -1 ? undefined : code;
};
/** Canonical gRPC name for a numeric code; undefined for anything that is not a gRPC code (0–16). */
export const getGrpcStatusName = (code) => GRPC_STATUS_NAMES.find((name, index) => index === code);
/** OK / ERROR for a canonical gRPC name; undefined otherwise, so callers fall through to the next status signal. */
export const classifyRpcResponseStatus = (value) => {
    const code = getGrpcStatusCode(value);
    if (code === undefined) {
        return undefined;
    }
    return code === 0 ? 'OK' : 'ERROR';
};
//# sourceMappingURL=grpc-status-names.js.map